import { useState } from "react";
import { useGlobalReducer } from "../../../GlobalContext";
import { AutomationStatus } from "../../config/enums";
import { ConfirmationModal } from "../../elements/ConfirmationModal";
import { PageActionModalProps } from "../recordDefinition.types";

/** Takes the automation off, cancelling what it had pending. */
export function AutomationUnpublishModal({
  record,
  onClose,
  onDone,
}: PageActionModalProps) {
  const globalDispatch = useGlobalReducer();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const unpublish = async () => {
    setIsSubmitting(true);

    try {
      // Loaded here so the page registry doesn't pull the automation service into every page.
      const { SetAutomationStatus } = await import("./automationService");
      const response = await SetAutomationStatus(
        globalDispatch,
        String(record.id),
        AutomationStatus.Unpublished,
        "Automation successfully unpublished"
      );

      if (response?.data) {
        onClose();
        onDone();
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ConfirmationModal
      modalTitle="Unpublish"
      confirmText="Unpublish"
      isSubmitting={isSubmitting}
      onClose={onClose}
      onConfirm={unpublish}
    >
      <p>
        Do you want to unpublish this automation? You can publish it again later, if you
        wish.
      </p>
      <p className="mb-0">
        This action will unpublish the automation and cancel any pending executions. It may
        take up to 5 minutes for this to take effect.
      </p>
    </ConfirmationModal>
  );
}

export default AutomationUnpublishModal;
